module.exports = __webpack_public_path__ + "static/img/m4.a1bbc57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/mobile/m4.png
// module id = hJmg
// module chunks = 12